import { ResourceInfoDc, unique } from "@evergis/api";
import { PUBLIC_ROLE } from "../../../../hooks/acl/publicAccess";

export const userNamesWithAccess = (resources: ResourceInfoDc[], currentUser: string, publicRoleAlias: string) =>
  !resources || resources.length === 0
    ? []
    : resources
        .reduce((acc, { acl }) => [...acc, ...acl.data], [])
        .filter(({ role }) => role !== `__${currentUser}`)
        .reduce(
          (acc, { role }) => (role === PUBLIC_ROLE ? [publicRoleAlias, ...acc] : [...acc, role.replace(/^(__)/, "")]),
          [],
        )
        .filter(unique);
